import { Loader2 } from 'lucide-react';
import { BlogContent } from '../../components/blog/BlogContent';
import { BlogPostCard } from '../../components/blog/BlogPostCard';
import { JsonLd } from '../../components/seo/JsonLd';
import { PageSeo } from '../../components/seo/PageSeo';
import { usePrerenderData } from '../../context/PrerenderDataContext';
import { MarketingLandingShell } from '../../components/marketing/MarketingLandingShell';
import { buildBlogIndexSchema } from '../../lib/blogSchema';
import { getAllPosts } from '../../lib/sanity';
import { BLOG_META } from '../../lib/seo';
import { useSanityFetch } from '../../lib/useSanityFetch';

export default function BlogPage() {
  const prerenderPosts = usePrerenderData()?.posts;
  const hasPrerenderPosts = prerenderPosts !== undefined;

  const { data: fetchedPosts, loading, error } = useSanityFetch(getAllPosts, [], {
    enabled: !hasPrerenderPosts,
  });

  const posts = hasPrerenderPosts ? prerenderPosts : fetchedPosts;
  const isLoading = !hasPrerenderPosts && loading;

  return (
    <>
      <PageSeo meta={BLOG_META} />
      <JsonLd data={buildBlogIndexSchema(posts ?? [])} />

      <MarketingLandingShell pageClassName="page-blog-index">
        <BlogContent>
          <header className="mb-12">
            <p className="label-mono">- Blog</p>
            <h1 className="font-display m-0 mt-[18px] text-[clamp(34px,4vw,54px)] leading-[0.95] tracking-[-0.02em] text-[#f2efea]">
              Guides &amp; insights
            </h1>
            <p className="mt-4 max-w-2xl text-[17px] leading-[1.65] text-on-surface-variant sm:text-[18px]">
              {BLOG_META.description}
            </p>
          </header>

          {isLoading && (
            <div className="flex justify-center py-20">
              <Loader2 size={32} className="animate-spin text-primary" aria-label="Loading posts" />
            </div>
          )}

          {error && (
            <p className="py-20 text-center text-on-surface-variant">
              Failed to load posts. Please try again.
            </p>
          )}

          {posts && posts.length === 0 && (
            <p className="py-20 text-center text-on-surface-muted">
              No posts published yet. Check back soon.
            </p>
          )}

          {posts && posts.length > 0 && (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {posts.map((post) => (
                <BlogPostCard key={post._id} post={post} />
              ))}
            </div>
          )}
        </BlogContent>
      </MarketingLandingShell>
    </>
  );
}
